import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TextFieldData from "../../GeneralDisclosure/TextFiledData";
import { Box, Button } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import { put, api, get } from "../../../../utils/api";
import styles from "../../../../styles/gri/general.module.css";
import GRISidebar from "../../../../Layout/GRISidebar";

import ReviewBox from "../../../../Components/Common/ReviewBox";
import { currentYear } from "../../../../utils/generateYearRanges";

const GRI201_3 = ({ hide }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const [fromData, setFromData] = useState({
    plansLiablities: { amount: "", currency: "" },
    // 2
    // separateFundExits: {
    schemesLibilites: { amount: "", currency: "" },
    estimateArrived: "",
    estimateMade: "",
    // },
    // 3
    employerFullCoverage: "",
    // 4
    salaryContributes: "",
    // 5
    retirementPlanParticipation: "",
  });
  const [griReview, setGriReview] = React.useState(() =>
    JSON.parse(localStorage.getItem("griReview"))
  );

  React.useEffect(() => {
    const handleStorage = () =>
      setGriReview(JSON.parse(localStorage.getItem("griReview")));
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);
  React.useEffect(() => {
    setGriReview(JSON.parse(localStorage.getItem("griReview")));
  }, []);

  const fetchData = async () => {
    await get(`/gri/get?type=GRI200&Id=${id}`)
      .then((res) => {
        if (
          res?.data?.data?.year
            ? res?.data?.data?.year < currentYear - 1
            : false
        )
          setDisabled(true);
        const gri200data = res.data.data.GRI200;
        setFromData({
          plansLiablities: {
            amount: gri200data?.plansLiablities?.amount,
            currency: gri200data?.plansLiablities?.currency,
          },
          // 2
          // separateFundExits: {
          schemesLibilites: {
            amount: gri200data?.schemesLibilites?.amount,
            currency: gri200data?.schemesLibilites?.currency,
          },
          estimateArrived: gri200data?.estimateArrived,
          estimateMade: gri200data?.estimateMade,
          // },
          // 3
          employerFullCoverage: gri200data?.employerFullCoverage,
          // 4
          salaryContributes: gri200data?.salaryContributes,
          // 5
          retirementPlanParticipation: gri200data?.retirementPlanParticipation,
        });
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    fetchData();
  }, []);

  const validateFields = () => {
    const newErrors = {};

    Object.keys(fromData).forEach((key) => {
      const value = fromData[key];
      console.log(key, "checking keys value");
      if (typeof value === "object" && value !== null) {
        // If the value is an object, validate its fields
        Object.keys(value).forEach((subKey) => {
          if (!value[subKey]) {
            if (!newErrors[key]) newErrors[key] = {}; // Ensure section exists
            newErrors[key][subKey] = "This field is required";
          }
        });
      } else {
        // If the field is a simple string, validate directly
        if (!value) newErrors[key] = "This field is required";
      }
    });

    console.log(newErrors, "newErrors");
    setErrors(newErrors);
    return newErrors;
  };

  // Function to handle form submission
  const handleSubmit = async () => {
    if (!disabled) {
      try {
        const token = sessionStorage.getItem("token");
        if (!token) {
          throw new Error("Authentication token is missing.");
        }
        await put(`/gri/update?Id=${id}`, {
          type: "GRI200",
          ...fromData,
          submitted201_3: true,
        })
          .then((res) => {
            navigate(`/gri/economic-performance/201-4/${id}`);
          })
          .catch((err) => {
            console.log(err);
          });
      } catch {
        console.log(errors);
      }
    } else {
      navigate(`/gri/economic-performance/201-4/${id}`);
    }
  };

  const inputData = [
    {
      index: "a.",
      heading:
        "If the plan’s liabilities are met by the organization’s general resources, the estimated value of those liabilities.",
      type: "flex",
      subfieldName: "plansLiablities",
      fields: [
        {
          subfieldName: "plansLiablities",
          fieldName: "amount",
        },
        {
          type: "select",
          currency: ["USD", "EUR", "INR"],
          currencyFieldName: "currency",
          fieldName: "",
          placeholder:"Currency"
        },
      ],
    },
    {
      index: "b.",
      heading:
        "If a separate fund exists to pay the plan’s pension liabilities:",
      subindex: "i.",
      subheading:
        "The extent to which the scheme’s liabilities are estimated to be covered by the assets that have been set aside to meet them",
      type: "flex",
      subfieldName: "schemesLibilites",
      fields: [
        {
          type: "flex",
          fieldName: "amount",
        },
        {
          type: "select",
          currency: ["USD", "EUR", "INR"],
          currencyFieldName: "currency",
          fieldName: "",
          placeholder:"Currency"
        },
      ],
      subheadings: [
        {
          index: "ii.",
          heading: "The basis on which that estimate has been arrived at;",
          type: "text",
          fieldName: "estimateArrived",
        },
        {
          index: "iii.",
          heading: "When that estimate was made",
          type: "date",
          fieldName: "estimateMade",
          width:"16%"
        },
      ],
    },
    {
      index: "c.",
      heading:
        " If a fund set up to pay the plan’s pension liabilities is not fully covered, explain the strategy, if any, adopted by the employer to work towards full coverage, and the timescale, if any, by which the employer hopes to achieve full coverage.",
      fieldName: "employerFullCoverage",
    },
    {
      index: "d.",
      heading: "Percentage of salary contributed by employee or employer.",
      fieldName: "salaryContributes",
      type: "percentage",
      placeholder:"Enter %"
    },
    {
      index: "e.",
      heading:
        "Level of participation in retirement plans, such as participation in mandatory or voluntary schemes, regional, or country-based schemes, or those with financial impact.",
      fieldName: "retirementPlanParticipation",
    },
  ];

  const renderContent = ({ hide }) => (
    <>
      {!hide && (
        <p className={styles.section_heading}>201:Economic Performance</p>
      )}
      <TextFieldData
        index=""
        title="201-3: Defined benefit plan obligations and other retirement plans"
        gridTemplateColumns="20% 50%"
        {...{
          inputData,
          fromData,
          setFromData,
          disabled: disabled,
          setErrors,
          errors,
          hide,
        }}
      />
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                  onClick={handleSubmit}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};
export default GRI201_3;
